export function reorderServicesSelectedFirst(
  services,
  selectedIdSet,
  originalIndexMap
) {
  if (!Array.isArray(services) || services.length === 0) {
    return services || [];
  }

  const getIdx = (service) => {
    const value = originalIndexMap?.get?.(service.id);
    return typeof value === "number" ? value : Number.MAX_SAFE_INTEGER;
  };

  const selected = [];
  const unselected = [];

  for (const service of services) {
    if (selectedIdSet?.has?.(service.id)) {
      selected.push(service);
    } else {
      unselected.push(service);
    }
  }

  selected.sort((a, b) => getIdx(a) - getIdx(b));
  unselected.sort((a, b) => getIdx(a) - getIdx(b));

  return [...selected, ...unselected];
}
